<template>
    <b-row>
        <b-col sm="12">
            <b-card no-body>
                <b-tabs card class="nav-fill">
                    <b-tab title="검색어 현황">
                        <SearchHistoryList />
                    </b-tab>
                    <b-tab title="인기검색어 설정">
                        <SearchManageList />
                    </b-tab>
                    <b-tab title="제외어 설정">
                        <SearchExceptManageList />
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import SearchHistoryList from './tabs/searchHistory/SearchHistoryList'
import SearchManageList from './tabs/searchManage/SearchManageList'
import SearchExceptManageList from './tabs/searchExceptManage/SearchExceptManageList'

export default {
    name: "searchTabs",
    components: {
        SearchHistoryList,
        SearchManageList,
        SearchExceptManageList,
    }
}
</script>
<style scoped>
table.b-table tbody td.searchArea {
    height: 47.59px;
}
</style>


// WEBPACK FOOTER //
// src/views/site/search/component/SearchTabs.vue